"use client";

import { setInquiryPopupObj } from "@/store/slices/inquirySlice";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router";
// import ReadMore from "../components/ReadMore";
// import Seo from "../components/Seo";
// import { CountryList } from "../services/CountryList";

export default function AboutUs({ aboutUsData }) {
  //   const [aboutUsData, setAboutUs] = useState(aboutDetails || null);
  const [isMobilescreen, setMobilescreen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    // let aboutData = {};
    // if (aboutUsData == null) {
    //   aboutData = pageList.find((page) => page.slug == "about-us");
    //   setAboutUs(aboutData);
    // }

    if (window.innerWidth <= 767) setMobilescreen(true);
    dispatch(setInquiryPopupObj(null));
  }, []);

  //   const seoMetaData = aboutUsData && {
  //     page_title: aboutUsData.seo_title || "About  Us | Swati Procon",
  //     page_description: aboutUsData.seo_description,
  //     page_keywords: aboutUsData.seo_keywords,
  //     slug: aboutUsData.slug,
  //     image: aboutUsData.seo_image_full
  //       ? aboutUsData.seo_image_full.includes("?")
  //         ? `${aboutUsData.seo_image_full}&w=1280&h=640`
  //         : `${aboutUsData.seo_image_full}?w=1280&h=640`
  //       : "/images/sswati-procon.png",
  //   };
  if (aboutUsData == null) {
    return <>Please Wait..</>;
  }

  return (
    <>
      {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}
      <div className="reecosys-main-wrapper" id="reecosys-main-wrapper">
        <div
          id="reecosys-aboutus-wrapper"
          className="relative inner-flex inner-flex-big section-padding pt0"
        >
          <section className="reecosys-section relative">
            <div className="common-listing-banner relative">
              <img
                src="/images/about/about-banner.jpg"
                className="hide-tab-mobile"
                alt="Desktop Banner"
              />
              {isMobilescreen && (
                <img
                  src="/images/about/about-banner-mob.jpg"
                  className="visible-tab-mobile"
                  alt="Mobile Banner"
                  style={{ height: "unset" }}
                />
              )}
            </div>
            <div className="top-left-overlay-new"></div>
          </section>
          <section
            className="reecosys-section relative"
            id="reecosys-aboutus-section-2"
          >
            <div className="main-container">
              <div className="new-about-grid-card">
                <div>
                  <div className="section-information">
                    <div className="section-title">
                      <h2 className="">{aboutUsData.title}</h2>
                    </div>
                  </div>
                </div>
                <div className="inner-flex inner-flex-medium">
                  <div className="inner-flex">
                    {aboutUsData.primary_text_display && (
                      <div className="section-paragraph readmoreText readmore-span-color">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: aboutUsData.primary_text_display,
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {aboutUsData.usp.length > 0 && (
                    <div className="flex-row flex-wrap highlightGrid inner-flex-big alc">
                      {aboutUsData.usp.map((data, index) => (
                        <div
                          key={index}
                          className="inner-flex inner-flex-smallest"
                        >
                          {data.name && (
                            <div className="banner-title">
                              <h2 className="capitalize medium-fonts">
                                {data.name}
                              </h2>
                            </div>
                          )}
                          {data.tag_line && (
                            <div className="section-content">
                              <p
                                className="capitalize"
                                dangerouslySetInnerHTML={{
                                  __html: data.tag_line,
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>

          <section
            className="reecosys-section relative"
            id="reecosys-aboutus-section-3"
          >
            <div className="main-container">
              {aboutUsData && (
                <div className="inner-flex inner-flex-big">
                  <div className="inner-flex">
                    <div className="section-title relative">
                      <h2 className="text-center text-lef-tmovile">
                        Leadership
                      </h2>
                    </div>

                    {aboutUsData.team_description && (
                      <div className="section-paragraph">
                        <p
                          className=""
                          dangerouslySetInnerHTML={{
                            __html: aboutUsData.team_description,
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <div className="grid-two-50-50-small">
                    {aboutUsData.profiles &&
                      aboutUsData.profiles.map((data, index) => (
                        <div
                          key={index}
                          className="inner-flex inner-flex-small"
                        >
                          <div>
                            <img
                              src={
                                data.profile_image_main
                                  ? `${data.profile_image_main}&h=548&w=732&q=100`
                                  : "https://dummyimage.com/732x548/c1c1c1/c1c1c1"
                              }
                              alt={data.profile_name}
                              style={{
                                width: "100%",
                                height: "auto",
                                filter: "grayscale(1)",
                              }}
                            />
                          </div>

                          <div className="">
                            <div className="inner-flex">
                              <div className="flex-row j-c-sb alc inner-flex-smallest">
                                {data.profile_name && (
                                  <div className="section-paragraph">
                                    <p className="semibold-fonts">
                                      {data.profile_name}
                                    </p>

                                    {data.profile_name ===
                                      "Mr. Ashok Agrawal" && (
                                      <p
                                        style={{
                                          fontSize: 16,
                                          color: "#999393",
                                        }}
                                      >
                                        Founder
                                      </p>
                                    )}
                                    {data.profile_name ===
                                      "Mr. Saket Agrawal" && (
                                      <p
                                        style={{
                                          fontSize: 16,
                                          color: "#999393",
                                        }}
                                      >
                                        Managing Director
                                      </p>
                                    )}
                                  </div>
                                )}

                                <div className="menber_social_links">
                                  <ul className="flex-row flex-row-socccc js-end alc">
                                    {data.facebook_url && (
                                      <li>
                                        <a
                                          href={data.facebook_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/facebook.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                    {data.linkedin_url && (
                                      <li>
                                        <a
                                          href={data.linkedin_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/linkedin.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                    {data.instagram_url && (
                                      <li>
                                        <a
                                          href={data.instagram_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/instagram.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                    {data.twitter_url && (
                                      <li>
                                        <a
                                          href={data.twitter_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="member_social_icons">
                                            <img
                                              src="/images/icon/social-icons/twitter.svg"
                                              alt={data.profile_name}
                                            />
                                          </div>
                                        </a>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>

                              {data.profile_description_short && (
                                <div className="section-paragraph readmore-span-color">
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: data.profile_description_short,
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
